// extracted by mini-css-extract-plugin
module.exports = {"rating":"style-module__rating___1c18P","centerButtons":"style-module__centerButtons___3nOtr","binaryFeedback":"style-module__binaryFeedback___ejalw"};